import { createFileRoute } from "@tanstack/react-router";
import { CreateTicketPage } from "@/components/pages/CreateTicketPage";

export const Route = createFileRoute("/tickets/new")({
  component: CreateTicketPage,
});
